module.exports = __webpack_public_path__ + "img/bd_other01.8ef44ddd.png";